import { makeAutoObservable } from 'mobx'
import { uiStore } from 'shared/store/uiStore'
import { logger } from 'shared/lib'
import { ComplianceApi, type IResponseTollFree, type IOptInMethodTypes } from 'entities/Compliance'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import type { TollFreeStepsStore } from 'pages/settings/pages/compliance/pages/tollFree/store/tollFreeStepsStore'
import {
  idToKeyMap,
  optInTollFreeMethodTypes,
} from 'pages/settings/pages/compliance/pages/tollFree/route/type'

export class OptInMethodStore {
  constructor(private _tollFreeStepsStore: TollFreeStepsStore, private _entities: IEntitiesStore) {
    makeAutoObservable(this)

    this._entities.complianceStore.loadOptInTypes()
  }

  private _optInMethods: IOptInMethodTypes[] = []

  get tollFreeStepsStore() {
    return this._tollFreeStepsStore
  }

  get optInMethods() {
    return this._optInMethods
  }

  get isNextDisabled() {
    return !this.optInMethods.length
  }

  getMethodData = (method: IOptInMethodTypes) => {
    return this._entities.complianceStore.optInTypesData.find(
      (item) => item.key === optInTollFreeMethodTypes[method]
    )
  }

  nextStepClick = async () => {
    const { profileId } = this.tollFreeStepsStore
    const relatableServiceType = '2' // backend waits it every time
    const { activeUseCaseNumber } = this.tollFreeStepsStore.useCaseDetailsStore
    const id = activeUseCaseNumber ? activeUseCaseNumber.individualTollFreeProfile?.id : profileId

    if (!id) return
    try {
      this.tollFreeStepsStore.setStepLoading(true)

      const optInData = this.optInMethods.map((method) => ({
        relatable_service_type: relatableServiceType,
        opt_in_method_id: this.getMethodData(method)?.id || 0,
      }))

      const { data } = await ComplianceApi.updateTollFreeOptInMethod(
        {
          opt_in_data: optInData,
        },
        id
      )

      if (data) {
        uiStore.changeRoute({
          path: this.tollFreeStepsStore.tollFreeNavigationStore.getNextUrl,
        })

        this.tollFreeStepsStore.setDataFromTollFreeRequest(data)
      }
    } catch (e) {
      logger.error(e)
    } finally {
      this.tollFreeStepsStore.setStepLoading(false)
    }
  }

  setOptInMethods = (value: IOptInMethodTypes) => {
    this.optInMethods.includes(value)
      ? (this._optInMethods = this.optInMethods.filter((item) => item !== value))
      : (this._optInMethods = [...this.optInMethods, value])
  }

  setOptInMethodsFromTollFree = (optInData: IResponseTollFree['opt_in_data']) => {
    optInData.forEach((method) => {
      this.setOptInMethods(idToKeyMap[method.opt_in_method_id])
    })
  }

  isOptInMethodActive = (value: IOptInMethodTypes) => {
    return this.optInMethods.includes(value)
  }
}
